import { render } from "./qrthorizondalpercentage.vue?vue&type=template&id=495c6a30&scoped=true"
import script from "./qrthorizondalpercentage.vue?vue&type=script&lang=js"
export * from "./qrthorizondalpercentage.vue?vue&type=script&lang=js"

import "./qrthorizondalpercentage.vue?vue&type=style&index=0&id=495c6a30&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-495c6a30"]])

export default __exports__